<div *ngIf="form.get(field)?.touched && form.get(field)?.invalid">
    <small style="color: #B00020" *ngIf="form.get(field)?.errors?.['required']">{{'Camp obligatori' |
        translate}}</small>
</div>